<script lang="typescript">
  import Calendar from './calendar/Calendar.svelte';
  import Day from './day/Day.svelte';
</script>

<main>
  <Calendar />
  <Day />
</main>

<style>
</style>

